import React from 'react';
import styles from './TimelineCard.module.scss';

interface SaveButtonProps {
  hasChanges: boolean;
  onSubmit: () => void;
}

export const SaveButton: React.FC<SaveButtonProps> = ({
  hasChanges,
  onSubmit
}) => {
  const handleSave = () => {
    if (!hasChanges) return; // Do nothing if no changes
    onSubmit();
  };

  return (
    <button
      onClick={handleSave}
      aria-label="Save reporting summary"
      disabled={!hasChanges}
      className={`${styles.saveButton} ${
        !hasChanges ? styles.saveButtonDisabled : ''
      }`}
    >
      Save
    </button>
  );
};
